import { Box, Divider, IconButton, Modal, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';

import { Form } from './Form';
import { Schema } from '@mui/icons-material';
import { WorkflowResponseDto } from '@bandido/shared/dtos';

interface WorkflowModalProps {
  open: boolean;
  onClose: () => void;
  agencyId: string;
  isEditMode?: boolean;
  data?: Partial<WorkflowResponseDto>;
}

export const WorkflowModal = ({ open, onClose, agencyId, isEditMode = false, data }: WorkflowModalProps) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const action = isEditMode ? 'edit' : 'create';

  return (
    <Modal open={open} onClose={onClose} aria-labelledby={t('workflows.create.title')}>
      <Box
        display="flex"
        flexDirection="column"
        gap={theme.spacing(2)}
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: theme.spacing(3),
          borderRadius: theme.spacing(2),
        }}
      >
        <Box display="flex" gap={theme.spacing(2)}>
          <Box flexGrow={1} display="flex" alignItems="center" gap={theme.spacing(1)}>
            <Schema color="disabled" />
            <Typography variant="h6" component="h2">
              {t(`workflows.${action}.title`)}
            </Typography>
          </Box>
          <IconButton onClick={onClose}>
            <CloseIcon color="primary" />
          </IconButton>
        </Box>
        <Divider />
        <Form agencyId={agencyId} onClose={onClose} isEditMode={isEditMode} data={data} />
      </Box>
    </Modal>
  );
};
